/**
 * Generic Affiliate Functionality
 */
$(document).ready(function() {
    $('.affiliate-theme input, .affiliate-theme select').on('invalid', function() {
        var ID = $('input:invalid,select:invalid')
            .first()
            .attr('ID');
        if (!$(this).val() && ID == $(this).attr('ID')) {
            var tabID =
                '#tab-' +
                $(this)
                    .parent()
                    .parent()
                    .attr('ID');
            $(tabID).click();
        }
    });

    $('.date').on('click',function(e) {
        $(this).siblings('span').click();
    });

    $('.show-user-menu, .dropdown-menu li a').click(function(e) {
        if ($('.user-dropdown').hasClass('open')) {
            $('.logged-in-user').removeClass('open');
        } else {
            $('.logged-in-user').addClass('open');
        }
    });

    $('.show-user-menu').on('click', function(event) {
        $(this)
            .parent()
            .toggleClass('open');
    });

    $('body').on('click', function(e) {
        if (
            !$('.user-dropdown .dropdown-menu').is(e.target) && // don't close popup if click within popup
            $('.user-dropdown .dropdown-menu').has(e.target).length === 0 &&
            $('.open').has(e.target).length === 0
        ) {
            $('.user-dropdown').removeClass('open');
            $('.logged-in-user').removeClass('open');
        }
    });
});

window.getKendoGridFilterableSettings = function() {
    var obj = {
        extra: true,
        operators: {
            string: {
                contains: 'Contains'
            },
            default: {
                contains: 'Contains'
            }
        }
    };

    return obj;
};

window.initializeTextFilterForKendoGrid = function(filterElement, textFields) {
    filterElement.container.find('.k-filter-help-text').remove();

    if (textFields.indexOf(filterElement.field) != -1) {
        filterElement.container
            .find('.k-textbox')
            .last()
            .remove();
        $([
            filterElement.container.find('[data-role="dropdownlist"]')[0],
            filterElement.container.find('[data-role="dropdownlist"]')[1],
            filterElement.container.find('[data-role="dropdownlist"]')[2]
        ]).each(function() {
            var list = $(this).data('kendoDropDownList');
            if (typeof list !== 'undefined') {
                list.destroy();
                list.wrapper.remove();
            }
        });
    }
};
